import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class Footer extends Component {
    render() {
        return (
            <div className="footer-wrap">
                <div className="is-row is-sm-row footer-content-wrap">
                    <div className="lg-gapr-160 md-gapr-60 sm-gapb-24">
                        <div className="footer-content-title">MJUInnovative</div>
                        <div className="footer-content gapb-18">
                            โทรศัพท์: 053-875-527<br/>
                            อีเมล: Innovativeindex.mju@gmail.com<br/>
                            63 หมู่ 4 ต.หนองหาร อ.สันทราย จ.เชียงใหม่ 50290<br/>
                            จันทร์ - ศุกร์: 8.30 น. – 16.30 น.
                        </div>
                        <div className="footer-social is-row">
                            <div className="gapr-16">
                                <img src="/resources/images/ic-facebook.svg" alt=""/>
                            </div>
                            <div className="gapr-16">
                                <img src="/resources/images/ic-twitter.svg" alt=""/>
                            </div>
                            <div className="gapr-16">
                                <img src="/resources/images/ic-google.svg" alt=""/>
                            </div>
                            <div>
                                <img src="/resources/images/ic-line.svg" alt=""/>
                            </div>
                        </div>
                    </div>
                    <div className="lg-gapr-160 md-gapr-60 sm-gapb-24">
                        <div className="footer-content-title">เว็ปไซต์</div>
                        <div className="footer-content">
                            <a href="/">หน้าแรก</a><br/>
                            <Link to="/innovations">งานวิจัยและนวัตกรรม</Link><br/>
                            <Link to="/news">ข่าวสาร</Link><br/>
                            <Link to="/webboard">กระดานสนทนา</Link>
                        </div>
                    </div>
                    <div>
                        <div className="footer-content-title">อื่นๆ</div>
                        <div className="footer-content">
                            <Link to="/">ข้อตกลงการใช้งาน</Link><br/>
                            <Link to="/">สิทธิความเป็นส่วนตัว</Link><br/>
                            <Link to="/">คำถามที่พบบ่อย</Link><br/>
                            <Link to="/contact">ติดต่อเรา</Link>
                        </div>
                    </div>
                </div>
                <div className="is-row footer-all-rights-reserved">© 2018 All Rights Reserved, MJUINNOVATIVE</div>
            </div>
        );
    }
}

export default Footer;
